
import { Component, Prop, Vue } from 'vue-property-decorator';

import * as ag_cli from 'ag-client-typescript';

import Tooltip from '@/components/tooltip.vue';
import { SYSADMIN_CONTACT } from '@/constants';
import { handle_global_errors_async } from '@/error_handling';
import { format_datetime, safe_assign } from '@/utils';

@Component({
  components: {
    Tooltip,
  }
})
export default class RerunTaskDetail extends Vue {
  @Prop({required: true, type: ag_cli.RerunSubmissionTask})
  task!: ag_cli.RerunSubmissionTask;

  readonly format_datetime = format_datetime;
  readonly SYSADMIN_CONTACT = SYSADMIN_CONTACT;

  @handle_global_errors_async
  async refresh_task(task: ag_cli.RerunSubmissionTask) {
    let refreshed = await ag_cli.RerunSubmissionTask.get_by_pk(task.pk);
    safe_assign(task, refreshed);
  }
}
